<div class="card">
    <div style="display: flex; align-items: center; padding: 10px;">
        <!--placeholder image-->
        <img style="height:64px" src="assets/runeandgear_logos/512hexagonlight.png"/>
        <span style="padding-left: 15px;">
            <h1 style="display: inline;">{{this.dataService.getScreenName()}}</h1>
        </span>
    </div>
    <hr style="height: 3px; background-color: gray;">
    <div style="display: flex;">
        <div class="column" style="display: flex; flex-direction: column; padding: 25px; border-right: 2px solid gray; gap: 15px;">
           <p-button [outlined]="true" label="Bio" icon="pi pi-shield" (onClick)="viewBio()"></p-button>
           <p-button [outlined]="true" label="Accessibility" icon="pi pi-hammer" (onClick)="viewAccessibility()"></p-button>
           <p-button [outlined]="true" label="Privacy and Security" icon="pi pi-cog" (onClick)="viewSecuritySettings()"></p-button>
           <p-button [outlined]="true" label="Communication Settings" icon="pi pi-envelope" (onClick)="viewCommunicationSettings()"></p-button>
        </div>
        <div style="display: flex; align-items: center; padding-left:15%;">
            <div *ngIf="bioVisible" label="Badges Content">
                <div style="display: flex; flex-direction: column;">
                    <h2>About Me</h2>
                    <p *ngIf="!isEditing" id="bio_text">{{platformUser.bioText}}</p>
                    <textarea *ngIf="isEditing" pInputText [(ngModel)]="platformUser.bioText" rows="6" cols="30" type="text" inputId="bio_text" id="bio_text"></textarea>
                    <p-button *ngIf="!isEditing" label="Edit Bio" icon="pi pi-pencil" (onClick)="editBio()"></p-button>
                    <p-button *ngIf="isEditing" label="Save Bio" icon="pi pi-check" (onClick)="saveBio()"></p-button>
                </div>
                <div style="padding-bottom: 25px; padding-top: 25px;">
                    <h2>Badges</h2>
                    <app-badge-display></app-badge-display>
                </div>
            </div>
            <div *ngIf="accessibilityVisible" label="Accessibility Content">
                <app-accessibility-page></app-accessibility-page>
            </div>
             <div *ngIf="securitySettingsVisible" label="Privacy and Security Content">
                <app-security-and-privacy-page></app-security-and-privacy-page>
            </div>
            <div *ngIf="communicationSettingsVisible" label="Communication Settings Content">
                <p>Coming Soon!</p>
            </div>
        </div>
    </div>
    
</div>
